import { setLoading, viewTransition, setCss, addParamsToUrl } from '../functions.js';
const { LitElement, html, repeat, ref, createRef, nothing } = window.globalLit;

customElements.define('dealer-locator', class DealerLocatorElement extends LitElement {
    static properties = {
        i18n:                { type: Object },
        fetchUrl:            { type: String },
        externalGeocoderUrl: { type: String },
        language:            { type: String },
        countries:           { type: Array },

        dealers:             { type: Array, state: true },
        hasSearched:         { type: Boolean, state: true },

    };

    #onceSelect = null;

    inputRef = createRef();
    listRef = createRef();
    sgRef = createRef();

    createRenderRoot() { return this; }

    constructor() {
        super();
        // this.files = [];
        this.hasSearched = false;
        this.style.display = 'none';
        this.i18n = {};
        this.language = 'en';

    }

    firstUpdated() {

        this.addEventListener('keydown', event => {
            if (event.key === 'Escape') {
                this.close();
            }
        });

        this.#initGeocoder();
    }

    #initGeocoder() {

        setCss(this.inputRef.value, {position:'relative', zIndex: 5});

        let countries = (this.countries && this.countries.length > 0) ? this.countries.join(',') : '';
        
        let options = {
            accessToken      : mapboxgl.accessToken,
            types            : 'address, postcode, place, neighborhood',
            language         : this.language,
            countries        : countries,
            limit            : 10,
            proximity        : 'ip',
            placeholder      : this.i18n.__PLACEHOLDER__,
            clearAndBlurOnEsc: true,
            enableGeolocation: true,
            addressAccuracy  : 'address',
            enableEventLogging: false,
        }

        if (this.externalGeocoderUrl) {
            options.externalGeocoder = (query) => {
                let url = addParamsToUrl(this.externalGeocoderUrl, {query});

                return fetch(url)
                        .then(res => res.json())
                        .then(data => {
                            return data.features;
                        });

            }
        }

        const geocoder = new MapboxGeocoder(options);

        geocoder.addTo(this.inputRef.value);

        geocoder.on('result', result => {
            this.fetchResults(result.result.center);
        });
    }

    fetchResults(center) {

        if (this.listRef && this.listRef.value) {
            setLoading(this.listRef.value, true);
        }

        let url = addParamsToUrl(this.fetchUrl, {lat: center[1], lng: center[0]});

        fetch(url , {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json'
            }
        })
        .then(res => res.json())
        .then(res => {
            if (this.listRef && this.listRef.value) {
                setLoading(this.listRef.value, false);
            }
            this.hasSearched = true;
            this.dealers = res.dealers;
            this.#scrollToTop();
            
        }).catch(err => {
            if (this.listRef && this.listRef.value) {
                setLoading(this.listRef.value, false);
            }
        });
    }

    close() {
        viewTransition(() => {
            this.style.display = 'none';
            this.ariaHidden = true;
        });
    }

    open(options) {
        this.#clearForm();

        viewTransition(() => {
            this.style.display = 'flex';
            this.ariaHidden = false;

            let input = this.querySelector('.dealerloc__geocoder input');
            input.focus();
            input.select();

            this.#scrollToTop();
            
            
            if (options.onSelect) {
                this.#onceSelect = options.onSelect;
            }

        });

        // this.fetchResults([-3.702979, 40.419224]);
    }

    #scrollToTop() {
        let list = this.querySelector('.dealerloc__list');
        list && list.scrollTo(0, 0);

        setTimeout(() => {
            this.sgRef && this.sgRef.value && this.sgRef.value.refreshGradients();
        }, 100);
    }

    #clearForm() {
        // @todo: implement
    }

    #onCloseClick() {
        this.close();
    }

    #onDealerClick(dealer) {
        let customEvent = new CustomEvent('dealer-selected', {
            detail: dealer
        });
        this.dispatchEvent(customEvent);

        if (this.#onceSelect) {
            this.#onceSelect(dealer);
            this.#onceSelect = null;
        }
        this.close();
    }

    getContent() {
        if (!this.hasSearched) {
            return nothing;
        }

        if (this.dealers && this.dealers.length > 0) {
            return html`
                <scroll-gradient ${ref(this.sgRef)}>
                    <ul class="dealerloc__list" ${ref(this.listRef)}>
                        ${repeat(
                            this.dealers,
                            (dealer) => dealer.id,
                            (dealer, index) => { 

                                let address = [dealer.address_1, dealer.address_2, dealer.address_3].filter(Boolean).join(', ');
                                let cityCounty = [dealer.address_town, dealer.address_county_district].filter(Boolean).join(', ');

                                return html`
                                    <li class="dealerloc__item">
                                        <button class="dealerloc__item__button" @click=${this.#onDealerClick.bind(this, dealer)}>
                                            <h4 class="dealerloc__item__title">${dealer.franchise_short_name}
                                                <small class="dealerloc__item__brand">${dealer.brand_name}</small>
                                            </h4>
                                            <p class="dealerloc__item__address">
                                                ${address}<br>
                                                ${cityCounty} ${dealer.address_postcode} <span>(${Math.round(dealer.distance / 1000, 2)} km)</span>
                                            </p>
                                        </button>
                                    </li>
                                `
                            }
                        )}
                    </ul>
                </scroll-gradient>`;
        } else {
            return html`
                <div class="dealerloc__noresults">
                    <strong>${this.i18n.__NO_RESULTS__TITLE__}</strong><br>
                    ${this.i18n.__NO_RESULTS__TEXT__}
                </div>
            `;
        }
        
    }

    render() {
        return html`
            <div class="dealerloc">
                <div class="dealerloc__modal">

                    <a href="javascript:void(0)" class="dealerloc__close" @click=${this.#onCloseClick.bind(this)}>&times;</a>

                    <div class="dealerloc__header">
                        <h3 class="dealerloc__title">${this.i18n.__TITLE__}</h3>
                        ${
                            this.i18n.__SUBTITLE__
                                ? html`<p class="dealerloc__subtitle">${this.i18n.__SUBTITLE__}</p>`
                                : nothing
                        }
                    </div>

                    <form class="dealerloc__form">
                        <div class="dealerloc__geocoder" ${ref(this.inputRef)}></div>
                    </form>

                    ${this.getContent()}
                  
                </div>
            </div>
        `;
    }
});

